<div class="supplementary-equipment">
  <div class="dialog-layout">

    <h2 class="dialog-h2">{{'Begleitmittel' | translate: ['tmc.transport.supplementaryEquipment.handout.title',
      translationService.language]}}</h2>

    <i class="horizontal-divider"></i>

    <div class="top-info">
      {{handout.name}} {{handout.firstname}} {{handout.company}}
    </div>

    <div class="dialog-content" [formGroup]="formGroup">

      <sc-flex [vertical]="true" [stretchContent]="true" class="no-field-space">
        <ng-container *ngFor="let se of handout.supplementaryEquipments">
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <sc-flex [formGroupName]="se.key">
            <div class="checkbox-label">
              <mat-checkbox formControlName="selected">
                {{se.dictionaryKey | translate:[se.dictionaryKey, translationService.language]}}</mat-checkbox>
            </div>
            <ng-container *ngIf="se.availableIdentifiers?.length > 0">
              <sc-content-spacer></sc-content-spacer>
              <mat-form-field class="checkbox-value">
                <mat-label>{{'Identity' | translate: ['tmc-common.entity.equipment.identifier', translationService.language]}}</mat-label>
                <mat-select name="identity" formControlName="identifier" [disabled]="!se.selected || isFormReadonly()" required="true">
                  <mat-option *ngFor="let identity of se.availableIdentifiers" [value]="identity">{{identity}}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <sc-content-spacer *ngIf="isStringParameter(se)"></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isStringParameter(se)" formControlName="parameter1Value">
              <input matInput required
                [disabled]="!se.selected || isFormReadonly()" [readonly]="isFormReadonly()"
                placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
            </mat-form-field>
            <sc-content-spacer *ngIf="isNumberParameter(se)"></sc-content-spacer>
            <mat-form-field class="checkbox-value" *ngIf="isNumberParameter(se)" formControlName="parameter1Value">
              <input matInput [type]="'number'" [(ngModel)]="se.parameter1Value" [ngModelOptions]="{standalone: true}"
                required [disabled]="!se.selected || isFormReadonly()" [readonly]="isFormReadonly()"
                placeholder="{{se.parameter1DictionaryKey | translate: [ se.parameter1DictionaryKey, translationService.language]}}">
            </mat-form-field>
          </sc-flex>
        </ng-container>
      </sc-flex>
    </div>

    <i class="horizontal-divider"></i>
    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
        ['tmc.transport.supplementaryEquipment.handout.action.cancel', translationService.language]}}</button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()">{{'save' |
        translate:
        ['tmc.transport.supplementaryEquipment.handout.action.save', translationService.language]}}</button>
    </sc-actionbar>
  </div>
</div>
